import { FC } from 'react';

import { Flex, rem, Text } from '@bonusly/design-system';

import { BugRecorder } from './bug-recorder';

/**
 * BugRecorderBanner - A banner for non-spoofing users to record bugs
 *
 * Shows when ?bug=true is in the URL. Similar style to the spoofing banner
 * but focused on bug recording.
 */
export const BugRecorderBanner: FC = () => {
	return (
		<Flex
			bgColor="blue.50"
			data-testid="bug-recorder-banner"
			py={rem(12)}
			paddingInline={{ base: '0.75rem', xs: '1.5rem' }}
			margin="0 auto"
			alignItems="center"
			justifyContent="space-between"
			position="sticky"
			top={0}
			zIndex={1000}
		>
			<Flex alignItems="center">
				<Text display="inline" color="blue.700" fontSize="md" fontWeight="normal" lineHeight={6} margin={0}>
					<Text as="span" fontWeight="semibold" fontSize="md">
						Bug Mode
					</Text>{' '}
					Record your screen to help debug issues.
				</Text>
			</Flex>
			<BugRecorder variant="banner" />
		</Flex>
	);
};

/**
 * Hook to check if bug recording mode is enabled via query param
 */
export const useBugMode = (): boolean => {
	if (typeof window === 'undefined') return false;
	const params = new URLSearchParams(window.location.search);
	return params.get('bug') === 'true';
};
